import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';

import { APP_INITIALIZER, LOCALE_ID, NgModule, Provider } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule, MatIconModule, MatMenuModule, MatPaginatorIntl, MatTooltipModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ControleVisualConfig, McticControleVisualModule, McticCoreModule, McticLayoutModule } from '@mctic/ng-core';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { CURRENCY_MASK_CONFIG } from 'ng2-currency-mask/src/currency-mask.config';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing-module';
import { initializer } from './keycloak-initializer';
import { CustomCurrencyMaskConfig, MatPaginatorIntlPtBr, SepinHttpInterceptor } from './shared';
import { HomeModule } from './home/home.module';
import { PerfilControleService } from './service/perfil-controle.service';

const HTTP_INTERCEPTOR_PROVIDERS: Provider[] = [
  {
    provide: APP_INITIALIZER,
    useFactory: initializer,
    multi: true,
    deps: [KeycloakService, PerfilControleService]
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: SepinHttpInterceptor,
    multi: true
  }
];

registerLocaleData(localePt, 'pt');

@NgModule({
  declarations: [AppComponent],
  exports: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    KeycloakAngularModule,
    ToastrModule.forRoot({preventDuplicates: true}),
    NgxMaskModule.forRoot({}),
    McticCoreModule,
    McticLayoutModule.forRoot(environment.layout),
    McticControleVisualModule.forRoot(
      new ControleVisualConfig(
        '/sepin-backend/rest/proxy/controle-visual/item-tela/sistema/SEPIN',
        '/sepin-backend/rest/proxy/controle-visual/menu/sistema/SEPIN'
      )
    ),
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    FlexLayoutModule,
    AppRoutingModule,
    HomeModule,
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'pt'},
    {provide: MatPaginatorIntl, useClass: MatPaginatorIntlPtBr},
    {provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig},
    HTTP_INTERCEPTOR_PROVIDERS
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
